<template>
  <HireActiveStatusLabel v-if="column?.activeStatus" :status="column.activeStatus" xs />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { graphql, FragmentType, useFragment } from '@/gql'
import HireActiveStatusLabel from '@/components/Common/HireActiveStatusLabel.vue'

const frag = graphql(`
  fragment HireActiveStatusColumn on Hire {
    id
    activeStatus
  }
`)

const props = defineProps<{
  row: FragmentType<typeof frag>
}>()

const column = computed(() => {
  if (!props.row) return null

  return useFragment(frag, props.row)
})
</script>
